import { UPDATE_CUSTOM_MARKERS } from "./customMarkersReducer";

export const updateCustomMarkers  = (info) => async (dispatch) => {
    dispatch({
        type: UPDATE_CUSTOM_MARKERS,
        payload: info
    })
}